const initialState = {
  guisOpen: []
};

export default initialState;
